import styled from 'styled-components';
import { Input } from '@m/alchemy-ui/Input';

export const ClearButton = styled.button`
  position: absolute;
  top: 50%;
  right: 0.7rem;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #545659;
  cursor: pointer;
  font-size: 0.7rem;
  padding: 0;

  &:before {
    content: '✕';
    display: inline-block;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const PopularTagWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const SearchInput = styled(Input).attrs(() => ({
  type: 'search'
}))`
  input::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
  }
`;

export const LiveRegion = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
